import { FaRegSadTear, FaSearch } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import Closet from "../photos/5865.jpg";
import useFetch from "../Components/FetchHook";
import ReactLoading from 'react-loading';
import Testimonials from "../Components/Testimonials";
import FeedbackForm from "../Components/feedback";
import FAQ from "../Components/faq";
// var data= require("./data.json")

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Home = () => {
  const navigate = useNavigate(); // Initialize the useNavigate hook
  const handleItemClick = (pid) => {
    const uniqueId = `${pid}-${uuidv4()}`; // Concatenate pid and UUID
    navigate(`/desc/${uniqueId}`); // Navigate to the Description page with the selected object ID
  };
  const { data, pending, error } = useFetch("https://campus-closet-server.vercel.app/items/products");

  const getRandomIndex = (maxIndex) => {
    return Math.floor(Math.random() * maxIndex);
  };
  const HouseLength = data?.filter((item) => item.product_category === "HouseHolds").length;
  const electroLength = data?.filter((item) => item.product_category === "Electronics").length;
  const OtherLength = data?.filter((item) => item.product_category === "Others").length;
  const FunituresLength = data?.filter((item) => item.product_category === "Funitures").length;

  // Assuming 'data' is your array of items
  const startIndexElectro = getRandomIndex(electroLength - 10); // Ensure at least 10 items remain
  const endIndexElectro = startIndexElectro + 10;
  // Assuming 'data' is your array of items
  const startIndexFaniture = getRandomIndex(FunituresLength - 10); // Ensure at least 10 items remain
  const endIndexFaniture = startIndexFaniture + 10;
  // Assuming 'data' is your array of items
  const startIndexOther = getRandomIndex(OtherLength - 10); // Ensure at least 10 items remain
  const endIndexOthers = startIndexOther + 10;

  const startIndexHouse = getRandomIndex(HouseLength - 10); // Ensure at least 10 items remain
  const endIndexHouse = startIndexHouse + 10;


  //This code is to handle resive to update the item preview section in the owlCalouser
  const [itemsToShow, setItemsToShow] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setItemsToShow(3);
      } else if (window.innerWidth > 768) {
        setItemsToShow(2);
      } else {
        setItemsToShow(1);
      }
    };

      // Initial setup
      handleResize();

      // Add event listener for window resize
      window.addEventListener("resize", handleResize);
  
      // Clean up the event listener when the component unmounts
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  return (
    <section className="">
      {/* Introduction section */}
      <div className=" mx-5 sm:mx-16 md:mx-28 lg:mx-40 flex homescreen">
        <div className=" my-10 md:mt-24">
          <h1
            style={{ color: "#F4A641" }}
            className=" text-3xl md:text-4xl font-serif underline"
          >
            The Campus Closet.
          </h1>
          <h2 className=" text-2xl md:text-3xl w-80 font-bold mt-5">
            Great deals and Sustainable shopping on Campus Closet.
          </h2>
          <p className="w-72 md:w-96 mt-5">
            Campus Closet is the go-to marketplace for students to buy and sell
            secondhand or new items. Whether you're looking to declutter your
            space, find a great deal on a household, or score a unique piece of
            decor, Campus Closet has got you covered. Join Our community today
            and discover a more sustainable affordable way to shop and sell on
            campus.
          </p>
          <p className="w-28 bg-black text-white text-center p-1 mt-10 rounded-md font-bold">
            <NavLink to="about">Learn More</NavLink>
          </p>
        </div>
        <div>
          <img src={Closet} alt="The campus closet" />
        </div>
      </div>

      {/* Conditionally rendered sections based on API response */}
      {pending ? (
        // Pending state
        <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
          <p>Loading...
            <ReactLoading type="spinningBubbles" color="#444654" height={'80px'} width={'80px'} />
          </p>
        </div>
      ) : error ? (
        // Error state
        <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
          <p>Failed to fetch Households products for display😢</p>
        </div>
      ) : (
        // Success state
        <section>
          {/* Electronics section */}
          <div>
            {data && data.some((item) => item.product_category === "Electronics") ? (
              <div className="mx-10 md:mx-28 lg:mx-40 mb-7">
                <h2 className="text-center text-xl mt-5 font-bold my-3">
                  Electronics
                </h2>

                
                <div className="overflow-x-auto whitespace-nowrap mx-auto bg-gray-100 rounded-sm">
                  <div className="">
                  <OwlCarousel
                    className="owl-theme mt-6 mx-auto"
                    items={itemsToShow}
                    loop={true}
                    autoplay={true}
                    autoplayTimeout={5000}
                    autoplayHoverPause={true}
                    nav
                    dots
                    margin={8}
                    center={true}
                    // navContainer=".custom-nav-container"
                    navText={[
                      '<span class="custom-prev-button text-lg font-bold"><</span>',
                      '<span class="custom-next-button text-lg font-bold">></span>'
                    ]}
                    // stagePadding= {100}
                  >
                    
                    {data
                      .filter((item) => item.product_category === "Electronics")
                       .slice(startIndexElectro, endIndexElectro)
                      .map((item, index) => (
                        <div
                          key={index}
                          className="shadow-2xl mx-auto mb-4 flex-shrink-0 w-60  h-60 rounded-md bg-white flex flex-col cursor-pointer"
                          style={{ transition: "transform 0.3s ease-in-out" }}
                          onClick={() => handleItemClick(item.pid)}
                        >
                          <img
                            className="h-48 w-full object-contain rounded-md"
                            src={item.image.replace("/v", "/q_35/v")}
                            alt={item.product_name}
                          />
                          <span className="ml-2">
                            <p className="truncate">{item.product_name}</p>
                            <p>KSh {item.price}</p>
                          </span>
                        </div>
                      ))}
           </OwlCarousel>
           </div>
          </div> 
                {/* <div className="overflow-x-auto whitespace-nowrap bg-gray-100 rounded-sm">
                  <div className="flex gap-5 justify-center px-4 md:px-10 py-16">
                    {data
                      .filter((item) => item.product_category === "Electronics")
                      .slice(0, 1)
                      .map((item, index) => (
                        <div
                          key={index}
                          className="shadow-2xl flex-shrink-0 w-60 mx-1 h-60 rounded-md bg-white flex flex-col cursor-pointer"
                          style={{ transition: "transform 0.3s ease-in-out" }}
                          onClick={() => handleItemClick(item.pid)}
                        >
                          <img
                            className="h-48 w-full object-contain rounded-md"
                            src={item.image.replace("/v", "/q_35/v")}
                            alt={item.product_name}
                          />
                          <span className="ml-2">
                            <p>{item.product_name}</p>
                            <p>KSh {item.price}</p>
                          </span>
                        </div>
                      ))}
                  </div>
                </div> */}
                <p
                  style={{ backgroundColor: "#F4A641" }}
                  className="w-28 bg-black text-white text-center p-1 mt-10 rounded-md font-bold ml-auto"
                >
                  <NavLink to="electronics">Load More</NavLink>
                </p>
              </div>
            ) : null}
          </div>

          {/* Households section */}
          <div>
            {data && data.some((item) => item.product_category === "HouseHolds") ? (
              <div className="mx-10 md:mx-28 lg:mx-40 mb-7">
                <h2 className="text-center text-xl mt-5 font-bold my-3">
                  Households
                </h2>
                <div className="overflow-x-auto whitespace-nowrap mx-auto bg-gray-100 rounded-sm">
                  <div className="">
                  <OwlCarousel
                    className="owl-theme mt-6 mx-auto"
                    items={itemsToShow}
                    loop={true}
                    autoplay={true}
                    autoplayTimeout={5000}
                    autoplayHoverPause={true}
                    nav
                    dots
                    margin={8}
                    center={true}
                    // navContainer=".custom-nav-container"
                    navText={[
                      '<span class="custom-prev-button text-lg font-bold"><</span>',
                      '<span class="custom-next-button text-lg font-bold">></span>'
                    ]}
                    // stagePadding= {100}
                  >
                    
                    {data
                      .filter((item) => item.product_category === "HouseHolds")
                      .slice(startIndexHouse, endIndexHouse)
                      .map((item, index) => (
                        <div
                          key={index}
                          className="shadow-2xl mx-auto mb-4 flex-shrink-0 w-60  h-60 rounded-md bg-white flex flex-col cursor-pointer"
                          style={{ transition: "transform 0.3s ease-in-out" }}
                          onClick={() => handleItemClick(item.pid)}
                        >
                          <img
                            className="h-48 w-full object-contain rounded-md"
                            src={item.image.replace("/v", "/q_35/v")}
                            alt={item.product_name}
                          />
                          <span className="ml-2">
                            <p className="truncate">{item.product_name}</p>
                            <p>KSh {item.price}</p>
                          </span>
                        </div>
                      ))}
           </OwlCarousel>
           </div>
          </div> 
                <p
                  style={{ backgroundColor: "#F4A641" }}
                  className="w-28 bg-black text-white text-center p-1 mt-10 rounded-md font-bold ml-auto"
                >
                  <NavLink to="households">Load More</NavLink>
                </p>
              </div>
            ) : null}
          </div>
          <div>
            {data && data.some((item) => item.product_category === "Funitures") ? (
              <div className="mx-10 md:mx-28 lg:mx-40 mb-7">
                <h2 className="text-center text-xl mt-5 font-bold my-3">
                Furniture
                </h2>
                <div className="overflow-x-auto whitespace-nowrap mx-auto bg-gray-100 rounded-sm">
                  <div className="">
                  <OwlCarousel
                    className="owl-theme mt-6 mx-auto"
                    items={itemsToShow}
                    loop={true}
                    autoplay={true}
                    autoplayTimeout={5000}
                    autoplayHoverPause={true}
                    nav
                    dots
                    margin={8}
                    center={true}
                    // navContainer=".custom-nav-container"
                    navText={[
                      '<span class="custom-prev-button text-lg font-bold"><</span>',
                      '<span class="custom-next-button text-lg font-bold">></span>'
                    ]}
                    // stagePadding= {100}
                  >
                    
                    {data
                      .filter((item) => item.product_category === "Funitures")
                      .slice(0, 10)
                      .map((item, index) => (
                        <div
                          key={index}
                          className="shadow-2xl mx-auto mb-4 flex-shrink-0 w-60  h-60 rounded-md bg-white flex flex-col cursor-pointer"
                          style={{ transition: "transform 0.3s ease-in-out" }}
                          onClick={() => handleItemClick(item.pid)}
                        >
                          <img
                            className="h-48 w-full object-contain rounded-md"
                            src={item.image.replace("/v", "/q_35/v")}
                            alt={item.product_name}
                          />
                          <span className="ml-2">
                            <p className="truncate">{item.product_name}</p>
                            <p>KSh {item.price}</p>
                          </span>
                        </div>
                      ))}
           </OwlCarousel>
           </div>
          </div> 
                <p
                  style={{ backgroundColor: "#F4A641" }}
                  className="w-28 bg-black text-white text-center p-1 mt-10 rounded-md font-bold ml-auto"
                >
                  <NavLink to="furniture">Load More</NavLink>
                </p>
              </div>
            ) : null}
          </div>
          <div>
            {data && data.some((item) => item.product_category === "Others") ? (
              <div className="mx-10 md:mx-28 lg:mx-40 mb-7">
                <h2 className="text-center text-xl mt-5 font-bold my-3">
                  Others
                </h2>
                <div className="overflow-x-auto whitespace-nowrap mx-auto bg-gray-100 rounded-sm">
                  <div className="">
                  <OwlCarousel
                    className="owl-theme mt-6 mx-auto"
                    items={itemsToShow}
                    loop={true}
                    autoplay={true}
                    autoplayTimeout={5000}
                    autoplayHoverPause={true}
                    nav
                    dots
                    margin={8}
                    center={true}
                    // navContainer=".custom-nav-container"
                    navText={[
                      '<span class="custom-prev-button text-lg font-bold"><</span>',
                      '<span class="custom-next-button text-lg font-bold">></span>'
                    ]}
                    // stagePadding= {100}
                  >
                    
                    {data
                      .filter((item) => item.product_category === "Others")
                      .slice(startIndexOther,endIndexOthers)
                      .map((item, index) => (
                        <div
                          key={index}
                          className="shadow-2xl mx-auto mb-4 flex-shrink-0 w-60  h-60 rounded-md bg-white flex flex-col cursor-pointer"
                          style={{ transition: "transform 0.3s ease-in-out" }}
                          onClick={() => handleItemClick(item.pid)}
                        >
                          <img
                            className="h-48 w-full object-contain rounded-md"
                            src={item.image.replace("/v", "/q_35/v")}
                            alt={item.product_name}
                          />
                          <span className="ml-2">
                            <p className="truncate">{item.product_name}</p>
                            <p>KSh {item.price}</p>
                          </span>
                        </div>
                      ))}
           </OwlCarousel>
           </div>
          </div> 
                <p
                  style={{ backgroundColor: "#F4A641" }}
                  className="w-28 bg-black text-white text-center p-1 mt-10 rounded-md font-bold ml-auto"
                >
                  <NavLink to="others">Load More</NavLink>
                </p>
              </div>
            ) : null}
          </div>
        </section>
      )}
       <FAQ />
      <Testimonials />
      <FeedbackForm />
    </section>
  );
};

export default Home;
